import styled from 'styled-components'
/***********************************************/
/** *******订餐页面的上班部分Order.js*************/
/***********************************************/
export const PatientInfo = styled.div`
  .ge5007e{
    color: #e5007e;
  }
  .g8a8a8a{
    color:#8a8a8a;
  }
  .minW0{ min-width: 0; }
`
export const HeaderWrapper = styled.div`
  .rdsbottom{
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
  box-shadow: 0 2.5px 6px rgba(0,0,0,0.1);
  .minW0{ min-width: 0; }
`
/* ---------Nav中间内容部分--------- */
/* 饮食医嘱部分 */
export const DoctorMsg = styled.div`
  .doctorIconBox{
      padding-left:32px;
      background-color:#fff;
      color:#444444;
      border-radius:0 8px 8px 8px;
  }
  .ge5007e{
    color:#e5007e;
  }
  .wMax53{
    max-width:53%;
  }
`
/* ---------Nav底部六个按钮部分--------- */
export const Navbottom = styled.ul`
  .g939192{
    color:#939192;
  }
  .g0{
    color:#000;
  }
  .food-type-active{
    transform:scale(1.2, 1.40625);
    border:1.1px solid #01d7a1;
    border-radius:2.5px;
  }
  .mask-box{
    background-color: #01d7a1;
    border-top-left-radius:5px;
    border-bottom-right-radius: 20px;
  }
  .markActive{
    transform:scale(1.28, 1.28);
  }
`
/***********************************************************/
/** *******订餐页面中间，结算部分OrderTabs.js**************/
/***********************************************************/
export const OrderMiddle = styled.div`
  height:100%;
  .markNum{
    background-color:#01d7a1;
    border-bottom-right-radius:20px;
  }
`
export const OrderTabsTop = styled.ul`
  .bg01d7a1{
    background-color:#01d7a1;
  }
  .l18p{
    left:18%;
  }
  .l29p{
    left:29%;
  }
  .gdcdedd{
    color:#dcdedd;
  }
  .boxShadowLeft{
    box-shadow: 3px 2px 5px rgba(0,0,0,0.2);
  }
  .boxShadowRight{
    box-shadow: -2px 2px 5px rgba(0,0,0,0.2);
  }
`
export const OrderTabsBottom = styled.div`
  .bgf6{
    background-color:#f6f6f6;
  }
  .foodListBox{
    box-shadow: 2.47px 2.47px 1.76px rgba(206,206,206,0.5);
  }
  .act{
    // box-shadow: 2.47px 2.47px 1.76px rgba(239,239,239,0.5);
    box-shadow: 2px 2px 1.5px rgba(206,206,206,0.5);
    border:0.5px solid rgba(206,206,206,0.5);
  }
  .bgf1{
    background-color:#f1f1f1;
  }
  .ga5{
    color:#a5a5a5;
  }
`
export const OrderTabsBottomFirst = styled.div`
  .bg01d7a1{
    background-color:#01d7a1;
  }
  .priceColor{
    color:#ff0660;
  }
  .rows {
    overflow: hidden;
    overflow-y: auto;
  }
  .rows::-webkit-scrollbar-track-piece {
    background-color: #f6f6f6;
    border-left: 1px solid rgba(0, 0, 0, 0);
  }
  .rows::-webkit-scrollbar {
    width: 0.2143rem;
    height: 5px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
  }
  .rows::-webkit-scrollbar-thumb {
    background-color: #b5b5b7;
    background-clip: padding-box;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    min-height: 5px;
  }
  .rows::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }
`
export const OrderTabsBottomSecond = styled.div`
  .priceColor{
    color:#ff0660;
  }
  .bg01d7a1{
    background-color:#01d7a1;
  }
  .rows {
    overflow: hidden;
    overflow-y: auto;
  }
  .rows::-webkit-scrollbar-track-piece {
    background-color: #f6f6f6;
    border-left: 1px solid rgba(0, 0, 0, 0);
  }
  .rows::-webkit-scrollbar {
    width: 0.2143rem;
    height: 5px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
  }
  .rows::-webkit-scrollbar-thumb {
    background-color: #b5b5b7;
    background-clip: padding-box;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    min-height: 5px;
  }
  .rows::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }
`
/***********************************************************/
/** *******订餐页面中间，OrderContentDetails.js**************/
/***********************************************************/
export const FoodDetailHeader = styled.div`
  border-bottom-left-radius: 20px;
  .bgf1{
    background-color:#f1f1f1;
  }
  .ga5{
    color:#a5a5a5;
  }
  .fs40{
    font-size:2.85rem;
  }
`
export const FoodDetailMiddle = styled.div`
  border-bottom-left-radius: 20px;
  box-shadow: 0 4px 5px rgba(0,0,0,0.1);
  .gred{
    color:#f4114e;
  }
  .g4f{
    color:#4f4f4f;
  }
  .g2e{
    color:#2e2e2e;
  }
  .bged{
    background-color:#ededed;
  }
  .priceColor{
    color:#f6590a;
  }
  .detailColor{
    color:#030303;
  }
  .g48{
    color:#484848;
  }
  .DecPos{
    right:50px;
    bottom:2px;
  }
  .NumPos{
    right:22px;
    bottom:5.5px;
  }
  .AddPos{
    right:5px;
    bottom:2px;
  }
`
export const FoodDetailBottom = styled.div`
  .g131313{
    color:#131313;
  }
`
/***********************************************************/
/** *******订餐页面下方，结算部分OrderShopping.js**************/
/***********************************************************/
export const OrderShoppingBar = styled.ul`
  bottom:0;
  .bg59{
    background-color:#595959;
  }
  .right-text{
    background-color:#01d7a1;
  }
`
export const OrderShoppingMask = styled.div`
    opacity:0.4;
`
export const OrdershoppingContent = styled.div`
  bottom:8%;
  margin-bottom:42px;
  border-top-left-radius:20px;
  .content-top{
    border-top-left-radius:20px;
    background-color:#edfcf9;
  }
  .food-type{
    background-color:#01d7a1;
  }
`
/***********************************************************/
/** *******订餐页面下方，点击结算后的确认页面**************/
/***********************************************************/
export const OrderDefinedHeaderWrapper = styled.div`
  height:14%;
  padding: 1% 3% 0;
`
export const OrderComfirmBox = styled.div`
  .outside-box{
    margin-bottom:47px;
  }
  .meal-type{
    background-color:#01d7a1;
  }
  .comfirm-item{
    border-radius:5px 5px 15px 15px;
    box-shadow: 3px 3px 6px rgba(211,211,211,0.58);
  }
  .bgf7{
    background-color:#f7f7f7;
  }
  .g4f{
    color:#4f4f4f;
  }
  .g6d{
    color:#6d6d6d;
  }
  .g70{
    color:#707070;
  }
`

export const OrderPay = styled.div`
  border-top-left-radius:20px;
  border-top-right-radius:20px;
  z-index:90;
  .g6d{
    color:#6d6d6d;
  }
  .g4f{
    color:#4f4f4f;
  }
  .g91{
    color:#919191;
  }
  .g6d{
    color:#6d6d6d;
  }
  .comfirm-pay{
    background-color:#00c14e;
  }
  .tip-color{
    color:#f11d69;
  }
`
